/**
 * Generación de archivos .ics (iCalendar) para agendar un remate.
 * Sin dependencias: arma el texto del evento y dispara la descarga.
 */

/** Formatea una fecha JS a UTC en el formato compacto que pide iCalendar: 20260622T143000Z */
function aFechaICS(fecha) {
  const p = (n) => String(n).padStart(2, '0');
  return (
    fecha.getUTCFullYear() +
    p(fecha.getUTCMonth() + 1) +
    p(fecha.getUTCDate()) + 'T' +
    p(fecha.getUTCHours()) +
    p(fecha.getUTCMinutes()) +
    p(fecha.getUTCSeconds()) + 'Z'
  );
}

/** Escapa caracteres especiales según RFC 5545 (comas, puntos y coma, saltos de línea) */
function escaparICS(texto = '') {
  return String(texto)
    .replace(/\\/g, '\\\\')
    .replace(/;/g, '\\;')
    .replace(/,/g, '\\,')
    .replace(/\r?\n/g, '\\n');
}

/**
 * Construye el contenido .ics de un remate.
 * @param {object} remate  Documento de la colección `remates`.
 * @param {Date}   inicio  Fecha/hora de inicio del remate.
 * @param {string} url     URL pública de la ficha (para incluir en la descripción).
 */
export function construirICS(remate, inicio, url) {
  // Duración estimada 1 h (los remates no traen hora de fin).
  const fin = new Date(inicio.getTime() + 60 * 60 * 1000);
  const uid = `remate-${remate.id || Date.now()}@formoprop`;
  const ubicacion = remate.modalidad === 'online'
    ? (remate.plataformaUrl || 'Remate online')
    : (remate.lugarRemate || remate.direccion || 'A confirmar');

  const titulo = `Remate: ${remate.caratula || remate.descripcion || 'Bien en remate'}`;
  const descripcionPartes = [
    remate.descripcion,
    remate.juzgado ? `Juzgado: ${remate.juzgado}` : '',
    remate.expediente ? `Expediente: ${remate.expediente}` : '',
    remate.base ? `Base: ${remate.moneda === 'USD' ? 'U$S' : '$'} ${remate.base}` : '',
    url ? `Ficha: ${url}` : '',
    'Información orientativa — rige el edicto judicial.',
  ].filter(Boolean).join('\n');

  const lineas = [
    'BEGIN:VCALENDAR',
    'VERSION:2.0',
    'PRODID:-//FormoProp//Remates//ES',
    'CALSCALE:GREGORIAN',
    'METHOD:PUBLISH',
    'BEGIN:VEVENT',
    `UID:${uid}`,
    `DTSTAMP:${aFechaICS(new Date())}`,
    `DTSTART:${aFechaICS(inicio)}`,
    `DTEND:${aFechaICS(fin)}`,
    `SUMMARY:${escaparICS(titulo)}`,
    `DESCRIPTION:${escaparICS(descripcionPartes)}`,
    `LOCATION:${escaparICS(ubicacion)}`,
    url ? `URL:${escaparICS(url)}` : '',
    'BEGIN:VALARM',
    'TRIGGER:-P1D',
    'ACTION:DISPLAY',
    'DESCRIPTION:Recordatorio de remate',
    'END:VALARM',
    'END:VEVENT',
    'END:VCALENDAR',
  ].filter(Boolean);

  return lineas.join('\r\n');
}

/**
 * Genera el .ics del remate y dispara la descarga en el navegador.
 */
export function descargarICS(remate, inicio, url) {
  const contenido = construirICS(remate, inicio, url);
  const blob = new Blob([contenido], { type: 'text/calendar;charset=utf-8' });
  const href = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = href;
  a.download = `remate-${remate.id || 'agenda'}.ics`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(href), 1000);
}
